import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { AuthConsumer } from '../services/AuthProvider';
import AppConstants from '../common/constants/AppConstants';

const pathList = AppConstants?.appInsights?.pathList
  ? AppConstants.appInsights.pathList
  : [];

export const PrivateRoute = ({ component, ...rest }) => {
  const appInsights = useAppInsightsContext();

  const location = useLocation();
  const path = location.pathname;

  const getPageName = (pagePathList, url) => {
    let pageName = null;
    let pageUrl = null;

    if (url && url !== '') {
      if (url === '/') {
        pageName = `${pathList[0].name}`;
        pageUrl = `${pathList[0].path}`;
      } else {
        for (let i = 1; i < pagePathList.length; i += 1) {
          if (
            url
              .trim()
              .toLowerCase()
              .indexOf(pathList[i].path.trim().toLowerCase()) > -1
          ) {
            pageName = `${pathList[i].name}`;
            pageUrl = `${pathList[i].path}`;
            break;
          }
        }
      }
    }
    return { pageName, pageUrl };
  };

  const logPageView = () => {
    const { pageName, pageUrl } = getPageName(pathList, path);
    const properties = appInsights.userDetails.role;
    appInsights.reactPlugin.trackPageView({
      name: pageName,
      uri: pageUrl,
      properties,
    });
  };

  const renderFn = (Component) => (props) =>
    (
      <AuthConsumer>
        {({ isAuthenticated, signinRedirect }) => {
          if (!!Component && isAuthenticated()) {
            logPageView();
            return <Component {...props} />;
          }
          signinRedirect();
          return <span>Loading</span>;
        }}
      </AuthConsumer>
    );

  return <Route {...rest} render={renderFn(component)} />;
};
